export const EXAMINATION_TYPES = {
    compulsory: { index: 1, label: '必須', questionsCount: 50 },
    general: { index: 2, label: '一般', questionsCount: 100 },
    practice: { index: 3, label: '実地', questionsCount: 50 },
};
export const getExaminationType = (index) => {
    const type = Object.values(EXAMINATION_TYPES).find(value => value.index === index);
    if (!type) {
        throw new Error(`指定された問題種別は存在しません index: ${index}`);
    }
    return type;
};
